import M$plugin$AddLayers from './/facade/js/addlayers';
import M$control$AddLayersControl from './/facade/js/addlayerscontrol';
import M$impl$control$AddLayersControl from './/impl/ol/js/addlayerscontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.AddLayers = M$plugin$AddLayers;
window.M.control.AddLayersControl = M$control$AddLayersControl;
window.M.impl.control.AddLayersControl = M$impl$control$AddLayersControl;
